<div class="mt-5 container" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row my-3">
        <div class="col-sm-12 text-right">IT- 10 BB (2023)</div>
    </div>
    <div class="row my-3">
        <div class="col-sm-12 text-center">
            <div class="font-weight-bold">Statement of Expenses Relating to Lifestyle</div>
            <div style="text-decoration: underline;">(For Individual Person)</div>
        </div>
    </div>
    <div class="row my-5">
        <div class="col-sm-5">Name of the Taxpayer: {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-7 text-right">
            TIN
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 living-expense-table">
            <div class="row bt bb bl">
                <div class="col-sm-1 text-center br">Serial No.</div>
                <div class="col-sm-7 text-center br">Particulars of Expenditure</div>
                <div class="col-sm-2 text-center br">Amount of Taka</div>
                <div class="col-sm-2 text-center br">Comments</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">1.</div>
                <div class="col-sm-7 br">Personal and family fooding, clothing and other essentials</div>
                <div class="col-sm-2 br">{{data?.Food_Cloth_Expense | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Food_Cloth_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">2.</div>
                <div class="col-sm-7 br">Housing Expense</div>
                <div class="col-sm-2 br">{{data?.House_Expense | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{data?.comments?.House_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">3.</div>
                <div class="col-sm-7 br">Personal Transport Expense</div>
                <div class="col-sm-2 br">{{data?.Transportation_Expense | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Transportation_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">4.</div>
                <div class="col-sm-7 br">Utility Expense (Electricity, Gas, Water, Telephone, Mobile, Internet etc. Bills)</div>
                <div class="col-sm-2 br">{{data?.Household_Utility_Expense | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Household_Utility_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">5.</div>
                <div class="col-sm-7 br">Education Expense</div>
                <div class="col-sm-2 br">{{data?.Child_Edu_Expense | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Child_Edu_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">6.</div>
                <div class="col-sm-7 br">Personal Expense for Local and Foreign Travel, Vacation etc.</div>
                <div class="col-sm-2 br">{{data?.domesticTravel | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{data?.comments?.commentForDomestic}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">7.</div>
                <div class="col-sm-7 br">Festival and Other Special Expense</div>
                <div class="col-sm-2 br">{{data?.otherAllWithoutDomestic + data?.Other_Expense | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{festivalSpecialExpenseComment}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">8.</div>
                <div class="col-sm-7 br">Tax Deducted / Collected at Source (with TS on Profit of Sanchaypatra) and Tax & Surcharge Paid based on Tax Return of Last Year</div>
                <div class="col-sm-2 br">{{ Tax_Surcharge_Payment_and_tax_at_source + data?.Tax_Environmental_Surcharge | currencySeparatorBD }}</div>
                <div class="col-sm-2 br">{{taxChargesComment}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">9.</div>
                <div class="col-sm-7 br">Interest Paid on Personal Loan Received from Institution & Other Source</div>
                <div class="col-sm-2 br">{{data?.Tax_Interest_Payment_Personal_Loan | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Tax_Interest_Payment_Personal_Loan}}</div>
            </div>
            <div class="row bb bl">
              <div class="col-sm-1 text-center br"></div>
                <div class="col-sm-7 text-right br">Total:</div>
                <div class="col-sm-2 br">{{data?.Expense_Tax_Total | currencySeparatorBD}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Expense_Tax_Total}}</div>
            </div>
        </div>
    </div>
    <div style="margin-top:80px" class="text-center">
      <u class="font-weight-bold">
        Verification
      </u>
  </div>
  <div class="text-center mt-3">
    I solemnly declare that to the best of my knowledge and belief the information given in this IT-10BB (2023) is correct and complete.
  </div>
  <div class="row" style="margin-top: 30px;">
      <div class="col-6"></div>
      <div class="col-6 text-center">
          {{returnData?.profileData?.assesName}} <br>
          Name & signature of the Taxpayer <br>
          Date:
          {{dateAfterSign}} <br>
          <strong><i>System generated document, it requires no signature</i></strong>
          <!-- <div class="font-italic font-weight-bold">সিস্টেম জেনারেটেড ডকুমেন্ট। স্বাক্ষরের প্রয়োজন নেই। </div>             -->
      </div>
  </div>
</div>

